window.UserSource = {
  sources: ["unknown"],
  remember: function (source_name) {
    return this.sources.push(source_name);
  },
  last: function () {
    return _.last(this.sources);
  }
};